import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formContainers marginBottom" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = ["checked", "value"]
const _hoisted_5 = { class: "formContainers marginBottom" }
const _hoisted_6 = { class: "formContainers marginBottom" }
const _hoisted_7 = { class: "formContainers" }
const _hoisted_8 = {
  key: 0,
  class: "image"
}
const _hoisted_9 = ["src"]

import { inject, computed, ref, reactive } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactSection',
  setup(__props) {

const displayWidth: any = inject(`displayWidth`);
const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});
const store: any = inject(`store`);
const radioArray = [
  { text: `Say Hi`, value: `greetengs`, checked: true },
  { text: `Get a Quote`, value: `quote` },
];
const providedData = reactive({
  action: `greetengs`,
  name: ``,
  email: { data: ``, valid: false, tag: ref() },
  message: { data: ``, valid: false, tag: ref() },
});
const isPending = ref(false);
const showDialog = ref(false);
const value = reactive({ status: ``, text: `` });

function checkValues(target: any, selector: string) {
  if (
    (selector === `email` &&
      target.data.match(
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g /* eslint-disable-line */
      )) ||
    (selector === `message` && target.data.length >= 10)
  ) {
    target.valid = true;
    target.tag.classList.remove(`redBorder`);
  } else {
    target.valid = false;
    target.tag.classList.add(`redBorder`);
  }
}

async function send() {
  checkValues(providedData.message, `message`);
  checkValues(providedData.email, `email`);
  if (providedData.email.valid && providedData.message.valid) {
    isPending.value = true;
    const returned = await store.dispatch(`sendRequest`, {
      name: providedData.name || null,
      action: providedData.action,
      email: providedData.email.data,
      message: providedData.message.data,
    });

    if (returned) {
      value.status = `Success`;
      value.text = `Message was sended succesfully`;
      providedData.action = `greetengs`;
      providedData.name = ``;
      providedData.email.data = ``;
      providedData.email.valid = false;
      providedData.message.data = ``;
      providedData.message.valid = false;
    } else {
      value.status = `Error`;
      value.text = `Please try send message later`;
    }

    isPending.value = false;
    showDialog.value = true;
    setTimeout(() => {
      showDialog.value = false;
    }, 2500);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_PendingButton = _resolveComponent("PendingButton")!
  const _component_MiniDialog = _resolveComponent("MiniDialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_SectionHeader, {
      title: "Contact Us",
      id: "contact",
      text: "Connect with Us: Let's Discuss Your Digital Marketing Needs"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
        class: "form"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(radioArray, (button) => {
            return _createElementVNode("label", {
              class: "radioContainer",
              key: button.value
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(button.text), 1),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "action",
                checked: button.checked,
                class: "customInput",
                value: button.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((providedData.action) = $event))
              }, null, 8, _hoisted_4), [
                [_vModelRadio, providedData.action]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "checkmark" }, null, -1))
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "name" }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text ",
            id: "name",
            placeholder: "Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((providedData.name) = $event))
          }, null, 512), [
            [_vModelText, providedData.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "email" }, "Email*", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email ",
            id: "email",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((providedData.email.data) = $event)),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (checkValues(providedData.email, `email`))),
            ref: (el) => (providedData.email.tag = el)
          }, null, 544), [
            [_vModelText, providedData.email.data]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "message" }, "Message*", -1)),
          _withDirectives(_createElementVNode("textarea", {
            name: "message",
            id: "message",
            placeholder: "Message",
            rows: "7",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((providedData.message.data) = $event)),
            onBlur: _cache[5] || (_cache[5] = ($event: any) => (checkValues(providedData.message, `message`))),
            ref: (el) => (providedData.message.tag = el)
          }, null, 544), [
            [_vModelText, providedData.message.data]
          ])
        ]),
        (!computedDisplayWidth.value)
          ? (_openBlock(), _createBlock(_component_PendingButton, {
              key: 0,
              isPending: isPending.value,
              send: send,
              color: "black",
              text: "Send Message",
              class: "button"
            }, null, 8, ["isPending"]))
          : _createCommentVNode("", true)
      ], 32),
      (!computedDisplayWidth.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("img", {
              src: require(`../assets/ContactUsIllustration.png`),
              alt: "Magic"
            }, null, 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (showDialog.value)
            ? (_openBlock(), _createBlock(_component_MiniDialog, {
                key: 0,
                values: value
              }, null, 8, ["values"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (computedDisplayWidth.value)
      ? (_openBlock(), _createBlock(_component_PendingButton, {
          key: 0,
          class: "button",
          isPending: isPending.value,
          send: send,
          color: "black",
          text: "Send Message"
        }, null, 8, ["isPending"]))
      : _createCommentVNode("", true)
  ]))
}
}

})